import React from 'react'

// Pill de status do design "Gestão de Pedidos" — recebe o MESMO shape dos mapas
// V1 utils/orderStatus e utils/paymentStatus ({type, description}), só muda a pele.
const COLORS = {
  ok: { bg: '#E8F4EE', fg: '#16603C' },
  warning: { bg: '#FFF4E2', fg: '#8A5A10' },
  denied: { bg: '#FDEAEA', fg: '#C2262B' },
}

// Discovery: "Pagamento recusado" não pode ter a mesma cor de "Aguardando pagamento".
// Os mapas V1 (utils/orderStatus e paymentStatus) classificam NP como warning — o
// override vive AQUI, só na V2; os mapas e as telas V1 permanecem intactos.
const V2_TYPE_OVERRIDES = { NP: 'denied', null: 'denied' }

export default function V2StatusPill({ type, description, id, code }) {
  const effectiveType = (code !== undefined && V2_TYPE_OVERRIDES[String(code)]) || type
  const c = COLORS[effectiveType] || COLORS.warning
  return (
    <span
      id={id}
      style={{
        display: 'inline-block',
        padding: '5px 12px',
        borderRadius: '100px',
        background: c.bg,
        color: c.fg,
        fontSize: '12px',
        fontWeight: '700',
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
      }}
    >
      {description}
    </span>
  )
}
